var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTableStripedA(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 34,
    viewBox: "0 0 76 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 81714"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 59995"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle Copy 211",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.761719 6.85474H75.7617V12.2821H0.761719V6.85474Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle Copy 211_2",
    d: "M0.861719 11.8573H75.6617V17.0847H0.861719V11.8573Z",
    fill: "white",
    stroke: "#F1F1F5",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle Copy 211_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.761719 16.9614H75.7617V22.3888H0.761719V16.9614Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle Copy 211_4",
    d: "M0.861719 22.265H75.6617V27.4924H0.861719V22.265Z",
    fill: "white",
    stroke: "#F1F1F5",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle Copy 211_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.761719 27.3687H75.7617V32.796H0.761719V27.3687Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle Copy 211_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.761719 0.349854H75.7617V5.77725H0.761719V0.349854Z",
    fill: "#B2B2BF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle Copy 211_7",
    d: "M0.799707 32.1H75.5997V33.9H0.799707V32.1Z",
    fill: "white",
    stroke: "#F1F1F5",
    strokeWidth: 0.2
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 24000",
    x: 3,
    y: 1,
    width: 14,
    height: 4,
    fill: "#707070"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableStripedA);
export default __webpack_public_path__ + "static/media/TableStripedA.6925623c621c72019919ebd55c113f14.svg";
export { ForwardRef as ReactComponent };